import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';

const googleLink = 'https://g.co/kgs/4Q5sCtz';

const FindUs = () => (
  <div className="app__bg app__wrapper section__padding" id="contact">
    <div className="app__wrapper_info">
      <SubHeading title="Contact" />
      <h1 className="headtext__cormorant" style={{ marginBottom: '2rem' }}>Find Us</h1>
      <div className="app__wrapper-content">
        <p className="p__cormorant" style={{ color: '#fff', margin: '2rem 0' }}>Location</p>
        <p className="p__opensans">Dominion Valley Market Square</p>
        <p className="p__opensans">5461 Merchants View Square</p>
        <p className="p__opensans">Haymarket, VA 20169</p>
        <p className="p__cormorant" style={{ color: '#fff', margin: '2rem 0' }}>Phone Number</p>
        <p className="p__opensans">703.753.5586</p>
        <p className="p__cormorant" style={{ color: '#fff', margin: '2rem 0' }}>Opening Hours</p>
        <p className="p__opensans">Mon - Fri: 10:00 am - 8:00 pm</p>
        <p className="p__opensans">Saturday: 9:00 am - 6:00 pm</p>
        <p className="p__opensans">Sunday: 10:00 am - 5:00 pm</p>
      </div>
      <a href={googleLink} target="_blank" rel="noopener noreferrer">
        <button type="button" className="custom__button" style={{ marginTop: '2rem' }}>Visit Us</button>
      </a>

    </div>

    <div className="app__wrapper_img">
      <img src={images.map} alt="finus_img" />
    </div>
  </div>
);

export default FindUs;